import React from "react";
import PatientCard from "./PatientCard";
import { useParams } from "react-router-dom";

const Patient = () => {
  let { branchId, patientId } = useParams();
  return (
    <PatientCard
      patientId={patientId}
      branchId={branchId}
      type={"fromPatient"}
    />
  );
};

export default Patient;
